import styled from 'styled-components';

export const MenuIconWrapper = styled.div`
    border: 1px solid #dfdfe0;
    padding: 15px;
    border-radius: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    cursor: pointer;
`;

export const Icon = styled.img`
  width: 32px;
  height: 32px;
`;

export const Title = styled.span`
  font-size: 12px;
  line-height: 1.2;
  font-weight: 500;
  color: #000000;
`;
